import styled from "styled-components";

const ShoppingListContainer = styled.div`
  margin: auto;
  margin-top: 40px;
  margin-bottom: 90px;
`;

export default ShoppingListContainer;
